var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.23306C0 9.70965 0.386359 10.096 0.862958 10.096H9.13586V12.9761L13.8149 9.23267L9.13586 5.48926V8.3701H0.862957C0.386359 8.3701 0 8.75646 0 9.23306Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3691 15.5856C19.0661 13.8886 20.001 11.6321 20.001 9.2324C20.001 6.83728 19.0691 4.58453 17.3774 2.88831L17.3675 2.87917C16.5316 2.03791 15.5518 1.38089 14.4563 0.927145C13.3676 0.476443 12.2187 0.248047 11.041 0.248047H10.9907C9.81372 0.248047 8.66412 0.476443 7.57619 0.927145C6.79917 1.24912 6.08019 1.673 5.42948 2.19229C5.05211 2.49344 5.05061 3.05189 5.39189 3.39338C5.72518 3.72688 6.26115 3.72754 6.63666 3.44242C7.89128 2.48981 9.41628 1.97396 11.0158 1.97396C12.9542 1.97396 14.7768 2.72919 16.1479 4.10033C17.5198 5.47223 18.2743 7.29484 18.2743 9.23316C18.2743 11.1715 17.5198 12.9941 16.1479 14.3652C14.7768 15.7371 12.9542 16.4916 11.0158 16.4916C9.41568 16.4916 7.89068 15.9754 6.6355 15.0225C6.26065 14.738 5.72574 14.7387 5.39296 15.0715C5.05136 15.4131 5.0535 15.972 5.43136 16.273C7.01366 17.5336 8.96414 18.2183 11.0158 18.2183C13.4155 18.2175 15.6721 17.2826 17.3691 15.5856Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.da552546203b5132b6c6a4b6e48fb6c8.svg";
export { ForwardRef as ReactComponent };